export const ABSENTEE_BID_FAILURE = 'la/ui/absenteeBid/FAILURE';
export const ABSENTEE_BID_REQUEST = 'la/ui/absenteeBid/REQUEST';
export const ABSENTEE_BID_SUCCESS = 'la/ui/absenteeBid/SUCCESS';

export const PUBNUB_GLOBAL_NOTIFICATION_RECEIVED = 'la/domain/globalNotification/PUBNUB_GLOBAL_NOTIFICATION_RECEIVED';
